import React, { useEffect, useState } from 'react';
import Layout from '../../elements/Layout';
import { getProjectCollections } from '../../utils/api/api';
import { Table, Input, Button } from 'antd';
import { Bar } from 'react-chartjs-2';
import * as XLSX from 'xlsx';
import 'chart.js/auto';
import { useNavigate } from 'react-router-dom';

const ProjectCollections = () => {
    const [data, setData] = useState(null);
    const [filteredData, setFilteredData] = useState(null);
    const [search, setSearch] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const getReport = async () => {
            try {
                const response = await getProjectCollections();
                setData(response.project_collections);
                setFilteredData(response.project_collections);
            } catch (error) {
                console.log(error);
            }
        };
        getReport();
    }, []);

    useEffect(() => {
        if (data) {
            const filtered = {
                expected_project_collections: data.expected_project_collections.filter(item =>
                    item.title.toLowerCase().includes(search.toLowerCase())
                ),
                total_project_collections: data.total_project_collections.filter(item =>
                    item.title.toLowerCase().includes(search.toLowerCase())
                ),
                project_arrears: data.project_arrears.filter(item =>
                    item.title.toLowerCase().includes(search.toLowerCase())
                ),
            };
            setFilteredData(filtered);
        }
    }, [search, data]);

    const exportToExcel = () => {
        const ws = XLSX.utils.json_to_sheet(filteredData.expected_project_collections);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Project Collections");
        XLSX.writeFile(wb, "ProjectCollections.xlsx");
    };

    const chartData = {
        labels: filteredData?.expected_project_collections.map(item => item.title),
        datasets: [
            {
                label: 'Expected Collection',
                data: filteredData?.expected_project_collections.map(item => item.expectedCollection || 0),
                backgroundColor: '#0A1929',
            },
            {
                label: 'Total Collection',
                data: filteredData?.total_project_collections.map(item => item.totalCollections || 0),
                backgroundColor: '#F8A81B',
            },
        ],
    };

    return (
        <Layout>
            <div className="p-6 border rounded-lg">
                <h2 className="text-2xl font-bold mb-4">Project Collections Report</h2>
                <div className="mb-4 flex items-center w-full gap-6 justify-between">
                    <Input
                        placeholder="Search by project name..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className=""
                    />
                    <button
                        onClick={exportToExcel}
                        className="bg-primary text-white px-4 py-1.5 rounded-md text-[14px] transition"
                    >
                        Export
                    </button>
                </div>
                <Bar data={chartData} />
                <table className="w-full mt-4 border-gray-200">
                    <thead className="bg-gray-100 text-gray-700">
                        <tr>
                            <th className="px-4 py-2 border-b border-gray-200 text-left">#</th>
                            <th className="px-4 py-2 border-b border-gray-200 text-left">Title</th>
                            <th className="px-4 py-2 border-b border-gray-200 text-right">Expected Collection</th>
                            <th className="px-4 py-2 border-b border-gray-200 text-right">Total Collection</th>
                            <th className="px-4 py-2 border-b border-gray-200 text-right">Arrears</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData?.expected_project_collections.map((item, index) => {
                            const expectedCollection = item.expectedCollection
                                ? Number(item.expectedCollection).toLocaleString()
                                : "N/A";

                            const totalCollections = filteredData?.total_project_collections.find(tc => tc.id === item.id)?.totalCollections
                                ? Number(filteredData.total_project_collections.find(tc => tc.id === item.id)?.totalCollections).toLocaleString()
                                : "N/A";

                            const expectedArrears = filteredData?.project_arrears.find(pa => pa.id === item.id)?.expectedArrears
                                ? Number(filteredData.project_arrears.find(pa => pa.id === item.id)?.expectedArrears).toLocaleString()
                                : "N/A";

                            return (
                                <tr key={item.id} onClick={() => navigate(`/dashboard/projects/${item.id}`)} className="border-b border-gray-200 hover:bg-gray-100 cursor-pointer transition">
                                    <td className="px-4 py-2 border-b text-black text-[13px] border-gray-200">{index + 1}</td>
                                    <td className="px-4 py-2 border-b text-black text-[13px] border-gray-200">{item.title}</td>
                                    <td className="px-4 py-2 border-b text-black text-[13px] border-gray-200 text-right">{expectedCollection}</td>
                                    <td className="px-4 py-2 border-b text-black text-[13px] border-gray-200 text-right">{totalCollections}</td>
                                    <td className="px-4 py-2 border-b text-black text-[13px] border-gray-200 text-right">{expectedArrears}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </Layout>
    );
};

export default ProjectCollections;
